import React, { useState } from 'react';

import { SearchOutlined } from '@ant-design/icons';
import { Space, Typography, Row, Col, Input, Button, Form } from 'antd';

import { Result } from './Result';
import { useShipment } from '../api/getShipment';

const { Text } = Typography;

export const Search = ({
  updateStep,
  setSelectedShipment,
}: {
  updateStep: (step: number) => void;
  setSelectedShipment?: (shipment: any) => void;
}) => {
  const [form] = Form.useForm();

  const [criterias, setCriterias] = useState<any>(undefined);
  const [hasSearched, setHasSearched] = useState(false);

  const { data, isLoading } = useShipment({
    config: {
      refetchOnWindowFocus: false,
      enabled: !!criterias,
    },
    criterias: criterias ?? undefined,
  });

  const shipments = Array.isArray(data) ? data : [];

  const handleSearch = (values: any) => {
    setCriterias({
      lpui: values.lpui,
      carrierTrackingCode: values.trackingNumber,
    });
    setHasSearched(true);
  };

  return (
    <>
      <Space style={{ padding: '24px' }}>
        <Row>
          <Col span={24}>
            <Text
              style={{
                fontSize: '1.125rem',
                fontWeight: '600',
                lineHeight: '135%',
                marginBottom: '8px',
                display: 'inline-block',
              }}
            >
              Search BOX for inspection
            </Text>
            <Text
              style={{
                fontSize: '1rem',
                fontWeight: 400,
                lineHeight: '135%',
                marginBottom: '1.5rem',
                display: 'inline-block',
              }}
            >
              Please enter the Carrier reference number or LPUI of the BOX you
              need to inspect.
            </Text>
          </Col>
          <Form
            form={form}
            layout="vertical"
            name="security_inspection_search"
            style={{ width: '100%' }}
            size="large"
            onFinish={handleSearch}
          >
            <Form.Item
              label="Tracking number"
              name="trackingNumber"
              style={{ fontSize: '1rem', fontWeight: 500, lineHeight: '125%' }}
            >
              <Input
                placeholder="Enter Carrier reference number/Tracking number"
                allowClear
                datates-id="trackingNumber"
                style={{
                  fontSize: '1rem',
                  fontWeight: 400,
                  lineHeight: '125%',
                }}
              />
            </Form.Item>

            <Form.Item
              label="LPUI"
              name="lpui"
              style={{ fontSize: '1rem', fontWeight: 500, lineHeight: '125%' }}
            >
              <Input
                datatest-id="lpui"
                placeholder="Enter LPUI"
                allowClear
                style={{
                  fontSize: '1rem',
                  fontWeight: 400,
                  lineHeight: '125%',
                }}
              />
            </Form.Item>
            <Form.Item>
              <Button
                htmlType="submit"
                style={{ width: '100%', borderRadius: '0.125rem' }}
                type="primary"
                loading={isLoading}
                disabled={isLoading}
              >
                <SearchOutlined />
                Search
              </Button>
            </Form.Item>
          </Form>
        </Row>
      </Space>
      {hasSearched && !isLoading && (
        <Space
          style={{
            width: '100%',
            height: '50%',
            background: '#FAFAFA',
            paddingTop: '16px',
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingBottom: '16px',
            borderTop: '1px solid #D9D9D9',
          }}
          direction="vertical"
          size={16}
        >
          <Result
            shipments={shipments}
            updateStep={updateStep}
            setSelectedShipment={setSelectedShipment}
          />
        </Space>
      )}
      {hasSearched && isLoading && (
        <Space
          style={{
            width: '100%',
            height: '50%',
            background: '#FAFAFA',
            paddingTop: '16px',
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingBottom: '16px',
            borderTop: '1px solid #D9D9D9',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Text
            style={{
              fontSize: '1rem',
              fontWeight: 400,
              lineHeight: '135%',
              color: '#595959',
            }}
          >
            Loading...
          </Text>
        </Space>
      )}
    </>
  );
};
